import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { forkJoin, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { deleteItemByKey } from 'src/app/core/store/root/storage';
import { MaquinaService } from 'src/app/maquinas/services/maquina.service';
import { IFiltroEstadisticaMaquina } from '../models/IFiltroEstadisticaMaquina';
import { IMaquinaInforme } from '../models/IMaquinaInforme';
import { IReporteInforme } from '../models/IReporteInforme';
import { loadCurrentMaquina, loadedCurrentMaquinaError, loadedCurrentMaquinaSuccess, loadedCurrentReportesChartDataSuccess } from './reporte.actions';

@Injectable()
export class InformeMaquinaEffects {
  constructor(private actions$: Actions, public dataService: MaquinaService) {

    this.loadReportes$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadCurrentMaquina),

        switchMap((payload: { form: IFiltroEstadisticaMaquina }) => {

          return forkJoin({
            informeMaquina: this.dataService.getReporte(payload.form),
          }).pipe(
            map((response: { informeMaquina: IMaquinaInforme }) => {
              deleteItemByKey('currentMaquina');
              return loadedCurrentMaquinaSuccess({ informeMaquina: response.informeMaquina });
            }),
            catchError((error) => of(loadedCurrentMaquinaError({ error })))
          );
        })
      )
    );
  

    this.loadReportesChartData$ = createEffect(() =>
      this.actions$.pipe(
        ofType(loadCurrentMaquina),

        switchMap((payload: { form: IFiltroEstadisticaMaquina }) => {

          return forkJoin({
            informeMaquina: this.dataService.getReporteChartsData(payload.form),
          }).pipe(
            map((response: { informeMaquina: IReporteInforme }) => {
              deleteItemByKey('currentMaquina');
              return loadedCurrentReportesChartDataSuccess({ reportes: response.informeMaquina });
            }),
            catchError((error) => of(loadedCurrentMaquinaError({ error })))
          );
        })
      )
    );
  
  }

  loadReportes$?: unknown
  loadReportesChartData$?: unknown
}
